import React, { ChangeEvent, InputHTMLAttributes, useState } from "react";
import { Eye, EyeOff } from "lucide-react";

type InputFieldProps = {
  id: string;
  name: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  label: string;
  className?: string;
} & Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "id" | "name" | "value" | "onChange"
>;

const InputField: React.FC<InputFieldProps> = ({
  id,
  type = "text",
  name,
  value,
  onChange,
  label,
  className = "",
  ...restProps
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const isPassword = type === "password";

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="relative">
      <label htmlFor={id} className="sr-only">
        {label}
      </label>
      <input
        id={id}
        type={isPassword && showPassword ? "text" : type}
        name={name}
        value={value}
        onChange={onChange}
        className={`${styles.inputItem} ${className}`}
        {...restProps}
      />
      {isPassword && (
        <button
          type="button"
          className="absolute inset-y-0 right-0 flex items-center pr-3"
          onClick={togglePasswordVisibility}
        >
          {showPassword ? (
            <EyeOff color="#9ca3af" className="h-5 w-5" />
          ) : (
            <Eye color="#9ca3af" className="h-5 w-5" />
          )}
        </button>
      )}
    </div>
  );
};

const styles = {
  inputItem:
    "w-full px-[12px] py-[14px] border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 text-black bg-[#F8F8F8]",
};

export default InputField;
